exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".restroom-opening .deployment-threshold-input {\n  max-width: 50px;\n  display: inline-block;\n  margin-right: 5px;\n}\n.restroom-opening .restroom-opening-time-input {\n  max-width: 70px;\n  display: inline-block;\n  margin-right: 5px;\n}\n.restroom-opening .kng-icon {\n  display: inline;\n}\n.restroom-opening .title {\n  padding-bottom: 20px;\n}\n.restroom-opening .details {\n  margin-left: 30px;\n}\n.restroom-opening .kng-radio {\n  margin-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/things/restroomOpening/restroomOpening.component.less
// module id = ../../../../../src/app/components/things/restroomOpening/restroomOpening.component.less
// module chunks = main